module.exports = __webpack_public_path__ + "img/HKULAW_logo.d02b7ff6.png";